import React from "react";

const FooterPortal: React.FC = () => {
  return (
    <footer className="bg-gray-900 text-gray-300 mt-16 font-signika">
      <div className="max-w-7xl mx-auto px-4 py-10 grid md:grid-cols-3 gap-10">
        {/* LOGO */}
        <div>
          <img alt="" src="/images/logo08.png" className="h-20 max-sm:h-12 mb-4" />
          <p className="text-sm leading-relaxed">Merah Putih 08 menyajikan informasi Program-program Prioritas Presiden.</p>
        </div>

        {/* KATEGORI */}
        <div>
          <h3 className="font-semibold text-white mb-4">Kategori</h3>

          <ul className="space-y-2 text-sm">
            <li>Nasional</li>
            <li>Politik</li>
            <li>Ekonomi</li>
            <li>Internasional</li>
            <li>Opini</li>
          </ul>
        </div>

        {/* KONTAK */}
        <div>
          <h3 className="font-semibold text-white mb-4">Redaksi</h3>

          <p className="text-sm">Email: redaksi@merahputih.com</p>

          <p className="text-sm mt-2">Telp: 08123456789</p>
        </div>
      </div>

      <div className="border-t border-gray-700 text-center py-4 text-sm">© 2026 Merah Putih 08 | All rights reserved</div>
    </footer>
  );
};

export default FooterPortal;
